/**
 * Partner Withdrawals API Service
 */

import { get, post } from "./client";

export interface WithdrawalBalance {
  totalCommission: number;
  totalWithdrawn: number;
  pendingAmount: number;
  availableBalance: number;
}

export interface Withdrawal {
  id: string;
  partnerId: string;
  amount: number;
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;
  status: "pending" | "processing" | "completed" | "rejected";
  notes: string | null;
  adminNotes: string | null;
  processedAt: string | null;
  createdAt: string;
}

interface WithdrawalsResponse {
  success: boolean;
  data: Withdrawal[];
}

interface WithdrawalResponse {
  success: boolean;
  message: string;
  data: Withdrawal;
}

interface BalanceResponse {
  success: boolean;
  data: WithdrawalBalance;
}

/**
 * Get partner's withdrawal history
 */
export async function getPartnerWithdrawals(): Promise<Withdrawal[]> {
  const response = await get<WithdrawalsResponse>("/partner/withdrawals");
  return response.data;
}

/**
 * Get partner's balance info
 */
export async function getPartnerBalance(): Promise<WithdrawalBalance> {
  const response = await get<BalanceResponse>("/partner/withdrawals/balance");
  return response.data;
}

/**
 * Request a new withdrawal
 */
export async function requestWithdrawal(data: {
  amount: number;
  notes?: string;
}): Promise<Withdrawal> {
  const response = await post<WithdrawalResponse>("/partner/withdrawals", data);
  return response.data;
}
